var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Autosizer, Scrollbar } from 'app/components';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const ChecklistTemplateHistoryList = () => {
    var _a;
    const history = (_a = useSelector((state) => { var _a; return (_a = state.checklist.templateSelectedItem) === null || _a === void 0 ? void 0 : _a.history; })) !== null && _a !== void 0 ? _a : [];
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.simplebar-horizontal': {
                right: '10px',
            },
            '.simplebar-vertical': {
                top: '30px',
                bottom: '0',
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 24, overscanCount: 10, itemCount: history.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: InnerElementType, itemData: {
                    items: history,
                } }, ItemRender))))))));
};
const InnerElementType = forwardRef((_a, ref) => {
    var { children, style } = _a, rest = __rest(_a, ["children", "style"]);
    return (React.createElement(List, Object.assign({ ref: ref, disablePadding: true, sx: {
            height: style === null || style === void 0 ? void 0 : style.height,
            minHeight: '100%',
        } }, rest),
        React.createElement(ListItem, { sx: (theme) => ({
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: style === null || style === void 0 ? void 0 : style.height,
                minHeight: '100%',
                zIndex: '2',
                pointerEvents: 'none',
                padding: theme.spacing(0),
                '.MuiListItemText-root': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '100%',
                    position: 'relative',
                    flex: 'none',
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        height: '100%',
                        bgcolor: theme.palette.divider,
                        width: '1px',
                        zIndex: '1',
                        pointerEvents: 'none',
                    },
                    '&:last-of-type': {
                        flex: '1',
                        '&:before': {
                            display: 'none',
                        },
                    },
                },
            }) }, config.checklistTemplateHistoryColumns.map((column) => (React.createElement(ListItemText, { key: column.name, style: { width: column.width } })))),
        children));
});
InnerElementType.displayName = 'ChecklistTemplateHistoryListInnerElementType';
const ItemRender = ({ data, index, style }) => {
    const { items } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: index, disablePadding: true, style: style, sx: (theme) => (Object.assign({ width: '100%', marginTop: '0px', userSelect: 'none', borderRadius: '0', '&:hover': {
                '.MuiListItemText-root': {
                    cursor: 'pointer',
                },
            }, '&.Mui-selected': {
                '.MuiListItemText-root': {
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                },
                '.MuiCheckbox-root': {
                    color: theme.palette.primary.contrastText,
                    '&.Mui-checked': {
                        color: theme.palette.primary.contrastText,
                    },
                },
            }, '.MuiListItemText-root': {
                display: 'flex',
                flex: 'none',
                height: '100%',
                margin: theme.spacing(0),
                padding: theme.spacing(0.5, 1),
                alignItems: 'center',
                '&:first-of-type': {
                    paddingLeft: theme.spacing(2),
                    svg: {
                        fontSize: '16px',
                        marginRight: '3px',
                    },
                },
                '&:last-of-type': {
                    flex: '1',
                    paddingRight: theme.spacing(2),
                },
                '.MuiTypography-root': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                },
                '.MuiCheckbox-root': {
                    padding: theme.spacing(0),
                    marginLeft: '-2px',
                    svg: {
                        fontSize: '18px',
                    },
                },
            } }, ((items.length - (items.length - 1 - index)) % 2 === 0 && {
            '& .MuiListItemText-root': {
                bgcolor: 'background.default',
            },
        }))) }, config.checklistTemplateHistoryColumns.map((column) => {
        var _a;
        return (React.createElement(ListItemText, { key: column.name, sx: { minWidth: column.width } }, React.createElement(Typography, null, column.format ? column.format(item[column.name]) : String((_a = item[column.name]) !== null && _a !== void 0 ? _a : ''))));
    })));
};
export default ChecklistTemplateHistoryList;
